import React, { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import { Copy, FileJson, ListCheck, Loader } from "lucide-react";
import {
  generateOvseQr,
  getOvseStatus,
  verifyPrefillv3Details,
} from "../../../Services/ApiTestService/apiTestService";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { isNumeric } from "validator";
import { useRef } from "react";
import QRCode from "qrcode";

function Ovse() {
  const { serviceName } = useService();

  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [expiryTime, setExpiryTime] = useState("60");
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [transactionId, setTransactionId] = useState(null);
  const [statusResponse, setStatusResponse] = useState(null);
  let apiResponse;

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(() => showSuccessToast("Copied!"));

    setIsJsonCopied(true);
  };

  // ---------------- generate qr ----------------
  const handleGenerate = async () => {
    if (!profileData) return;

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await generateOvseQr({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        consent: "Y",
        expiry_time_in_seconds: expiryTime,
      });

      if (res) {
        apiResponse = res;
        setTransactionId(res?.data?.transaction_id);

        console.log("========");
        console.log(apiResponse);
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else if (res?.status?.code === 422) {
        showErrorToast(res?.data?.message || "invalid details ");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!res.success) {
        showErrorToast(res?.data?.message || "verificaton failed");
      } else {
        showErrorToast(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  const getOvseStatusDetails = async () => {
    try {
      const res = await getOvseStatus({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        transaction_id: transactionId,
      });

      if (res?.status?.code === 200) {
        showSuccessToast(
          res?.data?.message || res?.data?.data?.message || res?.message,
        );

        setStatusResponse(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!transactionId) return;
    let timeout;

    if (statusResponse) {
      return;
    }
    timeout = setInterval(() => {
      getOvseStatusDetails();
    }, 10000);

    return () => {
      clearInterval(timeout);
    };
  }, []);

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={"OVSE QR"} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start py-14">
        {/* ---------------- FORM ---------------- */}
        <div className=" max-w-3xl border rounded-md sm:p-6 mt-6 bg-white">
          <div className="flex items-center flex-wrap gap-4">
            {/* Mobile */}
            <div className="flex items-center gap-4">
              <label className="w-32 font-bold">Select Expiration time</label>
              <select
                name=""
                id=""
                className="py-2 px-3 rounded-xl border"
                onChange={(e) => setExpiryTime(e.target.value)}
              >
                <option value="60">1 Minute</option>
                <option value="120">2 Minutes</option>
                <option value="300">5 Minutes</option>
                <option value="600">10 Minutes</option>
                <option value="900">15 Minutes</option>
                <option value="1200">20 Minutes</option>
                <option value="2400">40 Minutes</option>
                <option value="3600">60 Minutes</option>
              </select>

              {/* show input errors */}

              {inputError && (
                <div className="text-red-800 text-xl font-bold">
                  {inputError}
                </div>
              )}

              {/* Verify Button */}
              <div className="flex justify-end ">
                <button
                  disabled={isLoading}
                  onClick={handleGenerate}
                  className="px-6 py-2 bg-gradient-to-br hover:bg-black active:bg-green-600 from-blue-400 to-blue-800 text-white rounded-sm disabled:opacity-50"
                >
                  Generate Qr
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* response message */}

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {response?.data?.scan_uri && (
          <div className="mt-6 flex flex-col items-center">
            <h2 className="text-xl font-bold mb-4">Scan QR</h2>

            <CleanQR value={response.data.scan_uri} />

            <p className="text-xs mt-2 text-gray-500">
              Expires at: {new Date(response.data.expires_at).toLocaleString()}
            </p>
          </div>
        )}
      </div>
    </>
  );
}
export default Ovse;

function CleanQR({ value }) {
  const canvasRef = useRef();

  useEffect(() => {
    if (!value) return;

    QRCode.toCanvas(canvasRef.current, value, {
      width: 260,
      margin: 2,
      errorCorrectionLevel: "M",
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
    });
  }, [value]);

  return (
    <div className="bg-white p-4 rounded-md inline-block shadow">
      <canvas ref={canvasRef} />
    </div>
  );
}
